module.exports = __webpack_public_path__ + "img/card_recea_background.e03a9637.png";